import {identity} from 'lodash';
import React from 'react';

const Initials = props => {
    const {className, user} = props,
        initials = [user.first_name?.[0], user.last_name?.[0]].filter(identity).join('');

    return <div className={className}>{initials}</div>;
};

export default Initials;
